<template>
  <v-container>
    <span class="title">Link Click Statistics</span>
    <v-tabs v-model="activeTab" color="primary" class="mt-3">
      <v-tab class="white--text">Active Listings</v-tab>
      <v-tab class="white--text">Removed Listings</v-tab>

      <v-tab-item>
        <v-data-table
          :headers="activeHeaders"
          :items="linkClicks"
          :loading="loadingActive"
          :pagination.sync="activePagination"
          class="elevation-1 mt-2 fixed-table"
        >
          <template v-slot:items="props">
            <td class="truncate">{{ props.item.title }}</td>
            <td class="truncate">
              <a
                :href="props.item.website"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ props.item.website }}
              </a>
            </td>
            <td>{{ props.item.click_count }}</td>
            <td>{{ props.item.scan_count }}</td>
            <td>{{ props.item.total_count }}</td>
            <td>{{ formatDate(props.item.last_clicked) }}</td>
          </template>
          <template v-slot:no-data>
            <span>No click data yet.</span>
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item>
        <v-data-table
          :headers="removedHeaders"
          :items="removedListingClicks"
          :loading="loadingRemoved"
          :pagination.sync="removedPagination"
          class="elevation-1 mt-2 fixed-table"
        >
          <template v-slot:items="props">
            <td class="truncate">{{ props.item.listing_title }}</td>
            <td class="truncate">
              <a
                v-if="props.item.url"
                :href="props.item.url"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ props.item.url }}
              </a>
              <span v-else>—</span>
            </td>
            <td>{{ props.item.click_count }}</td>
            <td>{{ props.item.scan_count }}</td>
            <td>{{ props.item.total_count }}</td>
            <td>{{ formatDate(props.item.last_clicked) }}</td>
            <td>{{ formatDate(props.item.removed_at) }}</td>
            <td>
              <v-btn
                icon
                color="success"
                :disabled="!props.item.can_restore"
                :title="
                  props.item.can_restore
                    ? 'Restore listing'
                    : 'No restore data available'
                "
                @click="restoreListing(props.item)"
              >
                <v-icon>restore</v-icon>
              </v-btn>
              <v-btn
                icon
                color="error"
                @click="deleteRemovedListing(props.item)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>
            <span>No clicks from removed listings.</span>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 0,
      loadingActive: false,
      loadingRemoved: false,
      activePagination: { sortBy: "total_count", descending: true },
      removedPagination: { sortBy: "total_count", descending: true },
      activeHeaders: [
        { text: "Listing", value: "title", width: "24%" },
        { text: "URL", value: "website", width: "38%" },
        { text: "Clicks", value: "click_count", width: "8%" },
        { text: "Scans", value: "scan_count", width: "8%" },
        { text: "Total", value: "total_count", width: "8%" },
        { text: "Last Clicked", value: "last_clicked", width: "14%" }
      ],
      removedHeaders: [
        { text: "Listing", value: "listing_title", width: "18%" },
        { text: "URL", value: "url", width: "27%" },
        { text: "Clicks", value: "click_count", width: "6%" },
        { text: "Scans", value: "scan_count", width: "6%" },
        { text: "Total", value: "total_count", width: "6%" },
        { text: "Last Clicked", value: "last_clicked", width: "13%" },
        { text: "Removed On", value: "removed_at", width: "13%" },
        { text: "", value: "actions", sortable: false, width: "88px" }
      ]
    };
  },
  computed: {
    linkClicks() {
      return this.$store.state.linkClicks;
    },
    removedListingClicks() {
      return this.$store.state.removedListingClicks;
    }
  },
  async mounted() {
    this.loadingActive = true;
    this.loadingRemoved = true;
    await Promise.all([
      this.$store.dispatch("fetchLinkClicks"),
      this.$store.dispatch("fetchRemovedListingClicks")
    ]);
    this.loadingActive = false;
    this.loadingRemoved = false;
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "—";
      return new Date(dateStr).toLocaleString();
    },
    async restoreListing(item) {
      if (!confirm(`Restore "${item.listing_title}" and its click history?`)) {
        return;
      }
      await this.$store.dispatch("restoreListing", item.listing_id);
    },
    async deleteRemovedListing(item) {
      if (
        !confirm(
          `Are you sure you want to permanently delete the record for "${item.listing_title}"?`
        )
      ) {
        return;
      }
      await this.$store.dispatch("deleteRemovedListingClicks", item.listing_id);
      await this.$store.dispatch("fetchRemovedListingClicks");
    }
  }
};
</script>

<style scoped>
.fixed-table ::v-deep table {
  table-layout: fixed;
  width: 100%;
}

.fixed-table ::v-deep td,
.fixed-table ::v-deep th {
  padding: 0 8px !important;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixed-table ::v-deep th:last-child,
.fixed-table ::v-deep td:last-child {
  width: 88px !important;
  padding: 0 4px !important;
  text-align: center;
}

.fixed-table ::v-deep td:last-child .v-btn {
  margin: 0 2px !important;
}
</style>
